import { enums, number, object, optional, string } from 'superstruct'
import { PAYMENT_METHODS as BLOCKCHAIN_PAYMENT_METHODS } from '../blockchain/constants.js'
import { PAYMENT_METHODS as MOONPAY_PAYMENT_METHODS } from '../moonpay/constants.js'
import { PAYMENT_METHODS as ONRAMPER_PAYMENT_METHODS } from '../onramper/constants.js'
import { PAYMENT_METHODS as RAMP_PAYMENT_METHODS } from '../ramp/constants.js'
import { PAYMENT_METHODS as ROBINHOOD_PAYMENT_METHODS } from '../robinhood/constants.js'
import { PAYMENT_METHODS as SARDINE_PAYMENT_METHODS } from '../sardine/constants.js'
import { PAYMENT_METHODS as XOPAY_PAYMENT_METHODS } from '../xo-pay/constants.js'
import { PAYMENT_METHODS as PAYPAL_PAYMENT_METHODS } from '../paypal/constants.js'
import { ORDER_TYPES, PROVIDERS } from '../constants.js'
import { defaultedNull } from './utils.js'

const QuoteAsset = object({
  amount: optional(number()),
  asset: string(),
  maxBuyAmount: defaultedNull(number(), Number.MAX_SAFE_INTEGER),
  maxSellAmount: defaultedNull(number(), Number.MAX_SAFE_INTEGER),
  minBuyAmount: defaultedNull(number(), 0),
  minSellAmount: defaultedNull(number(), 0),
  precision: optional(number()),
})

export const Quote = object({
  extraFee: optional(number()),
  fee: optional(number()),
  from: QuoteAsset,
  metaProvider: optional(enums([PROVIDERS.onramper])),
  networkFee: optional(number()),
  paymentMethod: enums(
    [
      ...BLOCKCHAIN_PAYMENT_METHODS.values(),
      ...RAMP_PAYMENT_METHODS.values(),
      ...ROBINHOOD_PAYMENT_METHODS.values(),
      ...MOONPAY_PAYMENT_METHODS.values(),
      ...ONRAMPER_PAYMENT_METHODS.values(),
      ...[...SARDINE_PAYMENT_METHODS.values()].flat(),
      ...XOPAY_PAYMENT_METHODS.values(),
      ...PAYPAL_PAYMENT_METHODS.values(),
    ].map(({ id }) => id)
  ),
  provider: optional(string()),
  rate: optional(number()),
  to: QuoteAsset,
  totalAmount: optional(number()),
  totalFee: optional(number()),
  totalFeeCrypto: optional(number()),
  type: enums(Object.values(ORDER_TYPES)),
})
